import { useState } from "react";
import { leaveAPI } from '../../api/leaveAPI';
import UserPcode from '../../components/userPcode';
import Pagination from '../../components/pagination/pagination';
import { toast } from 'react-toastify';
import './employeeLeaveDetails.css';

export default function LeaveDetails() {

    const [isProcessing, setIsProcessing] = useState(false);

    const [selectedPcode, setSelectedPcode] = useState('');
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    const [empLeave, setEmpLeave] = useState([]);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10); // Records per page
    const [totalRecords, setTotalRecords] = useState(0);

    const handlePreview = () => {

        if (fromDate.trim().length === 0) { toast.warn('Please select a Date From'); return; }

        if (toDate.trim().length === 0) { toast.warn('Please select a Date To'); return; }

        if (new Date(fromDate) > new Date(toDate)) { toast.warn('Invalid Date Range'); return; }

        loadEmployeeLeaveDetails();
    }

    const loadEmployeeLeaveDetails = () => {
        setIsProcessing(true);
        leaveAPI.getEmployeeLeaveDetails(fromDate, toDate, selectedPcode)
            .then((data) => {
                setEmpLeave(data);
                setTotalRecords(data.length);
                setCurrentPage(1); // Reset to first page when new data is loaded
            })
            .catch((error) => {
                toast.error('Failed to load employee leave details');
                console.error('Error loading employee leave details:', error);
            })
            .finally(() => {
                setIsProcessing(false);
            });
    }

    // Calculate paginated data
    const getPaginatedData = () => {
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return empLeave.slice(startIndex, endIndex);
    };

    const totalPages = Math.ceil(totalRecords / pageSize);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const onChangePCode = (pcode) => { }

    return (
        <>
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 p-2 rounded contentLeveApproval form__body">
                    <div className="row mt-1">
                        <div className='col-2 col-sm-2 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4  text-start'></div>
                        <div className="col-8 col-sm-8 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center">
                            <h4>My Leave Details</h4>
                        </div>
                        <div className="col-2 col-sm-2 col-md-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 text-center"></div>
                    </div>

                    <div className="row">
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="input-group input-group-sm">
                                <UserPcode setSelectedPcode={setSelectedPcode} triggerOnChangePCode={onChangePCode} />
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                    <div className="row">
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="input-group input-group-sm">
                                <input value={fromDate} onChange={(e) => setFromDate(e.target.value)} type="date" className="form-control" placeholder='From Date' />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                            <div className="input-group input-group-sm">
                                <input value={toDate} onChange={(e) => setToDate(e.target.value)} type="date" className="form-control" placeholder='To Date' />
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9 text-end">
                            <div className="btn-group btn-group-sm">
                                <button
                                    onClick={handlePreview}
                                    type="button"
                                    className="btn btn-success"
                                    disabled={isProcessing}
                                >
                                    {isProcessing ? 'Loading...' : 'Preview'}
                                </button>
                            </div>
                        </div>
                        <div className='col-0 col-sm-0 col-md-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-2 table-responsive mt-0 pt-0'>
                            {/* Desktop Table View */}
                            <div className="desktop-table-view">
                                <table className="table text-nowrap employee-leave-table">
                                    <thead className="thead--color">
                                        <tr>
                                            <th>#</th>
                                            <th>Leave Date</th>
                                            <th>Leave Type</th>
                                            <th>Leave Reason</th>
                                            <th>Approved/Rejected Reason</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isProcessing ? (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    <div className="spinner-border spinner-border-sm" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <span className="ms-2">Loading...</span>
                                                </td>
                                            </tr>
                                        ) : getPaginatedData().length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">
                                                    No leave records found for the selected criteria
                                                </td>
                                            </tr>
                                        ) : (
                                            getPaginatedData().map((le, index) => (
                                                <tr key={index} className="employee-leave-row">
                                                    <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                                    <td>{le.startDate} - {le.endDate}</td>
                                                    <td>{le.leaveTypeName}</td>
                                                    <td>{le.employee_Reason}</td>
                                                    <td>{le.reason}</td>
                                                    <td>
                                                        <span className={`status-badge status-${le.transType.toLowerCase()}`}>
                                                            {le.transType.toUpperCase()}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile Card View */}
                            <div className="mobile-card-view">
                                {isProcessing ? (
                                    <div className="text-center p-4">
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <div className="mt-2">Loading...</div>
                                    </div>
                                ) : getPaginatedData().length === 0 ? (
                                    <div className="text-center text-muted p-4">
                                        No leave records found for the selected criteria
                                    </div>
                                ) : (
                                    getPaginatedData().map((le, index) => (
                                        <div key={index} className="mobile-leave-card">
                                            <div className="card-header">
                                                <div className="leave-dates">
                                                    <strong>{le.startDate} - {le.endDate}</strong>
                                                </div>
                                                <div className="leave-status">
                                                    <span className={`status-badge status-${le.transType.toLowerCase()}`}>
                                                        {le.transType.toUpperCase()}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="leave-info-row">
                                                    <span className="info-label info-type">Type</span>
                                                    <span className="info-value">{le.leaveTypeName}</span>
                                                </div>
                                                <div className="leave-info-row">
                                                    <span className="info-label info-reason">Reason</span>
                                                    <span className="info-value">{le.employee_Reason}</span>
                                                </div>
                                                {le.reason && (
                                                    <div className="leave-info-row">
                                                        <span className="info-label info-admin">Admin Note</span>
                                                        <span className="info-value">{le.reason}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            {/* Pagination Component */}
                            {!isProcessing && empLeave.length > 0 && (
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalRecords={totalRecords}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}